import requestUtil from '../request-utils.js'
import commonUtlis from '../common-utlis.js'
import i18n from '../../i18n'
import {
	constant,
	allUserSettingKeyList,
	bigUserSettingKeyList
} from '../../config.js'
import {
	getTimelinesData,
	setTimelinesData,
	updateTimelinesData
} from './data-refresh.js'

/**
 * 获取全部配置表参数
 * @param {string} keys  
 */
const getAllParam = async (isRefresh = false) => {
	// 优先获取已有数据
	let params = getTimelinesData(constant.DATA_KEY_USER_SETTING, false);
	if (params && !isRefresh) {
		return params;
	}

	// 优先获取已有数据
	params = await __getParamFromOrigin(); // 从服务器获取用户配置数据

	// 保存更新数据
	if (params) {
		// 更新缓存数据
		setTimelinesData(constant.DATA_KEY_USER_SETTING, params);
		// 将部分数据设置到缓存
		_setParamsToStorage(params);
	}

	return params;
}

/**
 * 获取配置表参数
 * @param {string} keys  
 */
const getParam = async (keys) => {
	// 获取所有配置项（除去大字段和隐私字段）
	let allParams = await getAllParam();

	// 遍历所需key，有缺失的需要单独读取
	let normalParams = {};
	let bigKeyList = [];
	keys.split(',').forEach(key => {
		key = key.trim();
		// 请求key不在大字段，则在全部配置中获取
		if (!bigUserSettingKeyList.includes(key)) {
			normalParams[key] = allParams[key] || "";
		} else {
			bigKeyList.push(key);
		}
	});

	// 获取大字段配置
	let bigParams = {};
	if (bigKeyList.length > 0) {
		bigParams = await _getBigkeyParams(bigKeyList);
	}

	return {
		...normalParams,
		...bigParams
	};
}

/**
 * 获取配置表参数
 */
const _getBigkeyParams = async (keyList) => {
	let resParams = {};
	let needGetKeyList = [];
	// 遍历结果，优先获取缓存中的数据
	keyList.forEach(key => {
		// 优先获取已有数据
		let val = getTimelinesData(`${constant.DATA_KEY_USER_SETTING_BIG_KEY}_${key}`);
		if (val != null) {
			resParams[key] = val;
		} else {
			needGetKeyList.push(key);
		}
	});

	// 还存在需要获取的配置，则调用接口获取，并添加到缓存
	if (needGetKeyList.length > 0) {
		// 通过接口获取最新的配置
		let originParams = await __getParamFromOrigin(needGetKeyList.join(","));
		// 将配置补充到返回结果，并添加到缓存
		needGetKeyList.forEach(key => {
			resParams[key] = originParams[key] || "";
			setTimelinesData(`${constant.DATA_KEY_USER_SETTING_BIG_KEY}_${key}`, resParams[key]);
		});
	}

	return resParams;
}

/**
 * 获取缓存中的配置表参数（只获取缓存，适用于部分不方便使用异步方法的页面）
 * @param {string} keys  
 */
const getParamByKeysFromCache = (keys) => {
	// 优先获取已有数据
	let param = JSON.parse(localStorage.getItem(constant.DATA_KEY_USER_SETTING) || "{}");

	// 返回查询配置信息
	let paramResult = {};
	keys.split(",").map(t => {
		paramResult[t] = param[t];
	});

	// 返回结果
	return paramResult;
}

/**
 * 将用户配置添加到缓存
 * @param {*} params 
 */
const _setParamsToStorage = (params) => {
	// 默认渠道Id
	localStorage.setItem("pc_channelId", params.bindSaleChannelId);
	// 默认渠道名称
	localStorage.setItem("pc_channelName", params.bindSaleChannelName);
	// 默认仓库ID
	localStorage.setItem("pc_warehouseId", params.bindWarehouseId);
}

/**
 * 从服务器获取用户配置数据
 */
const __getParamFromOrigin = async (paramKeys) => {
	return new Promise((resolve, reject) => {
		// 检测当前参数在缓存中是否已经存在
		requestUtil.jackyunPost({
			method: "jmall.param.getparamv1",
			paramKeys,
			queryAll: !paramKeys
		}, (res) => {
			let data = [];
			if (res.code == 200) {
				data = res.result.data || [];
			} else {
				console.log("获取用户配置失败", res);
			}

			// 生成结果对象并返回
			let params = {};
			data.forEach(t => {
				if (t && t.paramKey) {
					params[t.paramKey] = t.paramValue;
				}
			});
			resolve(params);
		});
	})
}

/**
 * 检测区域可购
 * @param {*} logisticType 
 * @param {*} addressInfo 
 */
const checkCanOrderAreasByParams = async (logisticType, addressInfo) => {
	// 自提模式不检测
	if (logisticType == 2) {
		return {
			canOrder: true,
			needStreet: false,
			hasThreeLevelMatchedRule: false,
			purchaseLimitTip: '',
		};
	}

	let paramList = await getParam("isOpenCityBuyLimit,buyLimitCities,purchaseLimitTip");
	let canOrderAreaList = JSON.parse(paramList.buyLimitCities || "[]");
	let isOpenCityBuyLimit = paramList.isOpenCityBuyLimit == "1";
	let purchaseLimitTip = paramList.purchaseLimitTip || i18n.t("api_utils.api_params.009092-0");

	// 未开启或者未设置限购地区，则不做展示
	if (!isOpenCityBuyLimit || !(canOrderAreaList.length > 0)) {
		return {
			canOrder: true,
			needStreet: false,
			hasThreeLevelMatchedRule: false,
			purchaseLimitTip: '',
		};
	}

	// 获取当前地址的省市区信息
	let {
		province = "", city = "", district = ""
	} = addressInfo;
	let street = getAddressStreet(addressInfo);
	let adrProvince = province.substring(0, 2) || "";
	let adrCity = city.replace("市", "") || "";
	let adrDistrict = district.replace("县", "").replace("区", "") || "";
	let adrStreet = normalizeStreetValue(street);

	// 处理省份信息
	canOrderAreaList.forEach(t => {
		t.province = t.province.substring(0, 2) || "";
		t.city = t.city.replace("市", "") || "";
		t.town = t.town.replace("县", "").replace("区", "") || "";
		t.street = normalizeStreetValue(t.street);
	});

	let hasThreeLevelMatchedRule = false;
	let needStreet = false;

	// 检测是否可以下单
	let canOrder = canOrderAreaList.findIndex(t => {
		let isThreeLevelMatched = t.province == "全部" ||
			(t.province == adrProvince && t.city == "全部") ||
			(t.province == adrProvince && t.city == adrCity && t.town == "全部") ||
			(t.province == adrProvince && t.city == adrCity && t.town == adrDistrict);

		if (!isThreeLevelMatched) {
			return false;
		}

		hasThreeLevelMatchedRule = true;
		if (isAllStreetRule(t.street)) {
			return true;
		}

		if (!adrStreet) {
			needStreet = true;
			return false;
		}

		return splitStreetValues(t.street).includes(adrStreet);
	}) >= 0;

	return {
		canOrder,
		needStreet: !canOrder && needStreet,
		hasThreeLevelMatchedRule,
		purchaseLimitTip,
	};
}

const getAddressStreet = (addressInfo = {}) => {
	return (addressInfo.street || addressInfo.town || '').trim();
}

const normalizeStreetValue = (street) => {
	return (street || '').split('，').join(',').trim();
}

const isAllStreetRule = (street) => {
	return !street || street == '全部' || street == '0';
}

const splitStreetValues = (street) => {
	let streetValue = normalizeStreetValue(street);
	if (isAllStreetRule(streetValue)) {
		return [];
	}
	return streetValue.split(',').map(item => item.trim()).filter(Boolean);
}

/**
 * 获取配置表参数
 */
const getSingleParam = async (key, isFromOrigin = false) => {
	let params = {};

	// 直接获取服务端数据
	if (isFromOrigin) {
		params = await __getParamFromOrigin(key);
	}
	// 大字段配置判断
	else if (bigUserSettingKeyList.includes(key)) {
		params = await _getBigkeyParams([key]);
	}
	// 获取所有配置
	else {
		params = await getAllParam();
	}

	return params[key] || "";
}

/**
 * 检测配置是否开启
 */
const isOpenConfig = async (key) => {
	let config = await getSingleParam(key);
	return config == "1";
}


/**
 * 从服务器获取用户单个配置数据
 * @param {*} key 
 */
const getSingleParamFromOrigin = async (key) => {
	// 无效key不处理
	if (!key) {
		return "";
	}

	// 获取配置参数
	let param = await __getParamFromOrigin(key);
	return param[key] || '';
}

//可以被外部引用的方法
export {
	getParam,
	checkCanOrderAreasByParams,
	getAllParam,
	getParamByKeysFromCache,
	isOpenConfig,
	getSingleParam,
	getSingleParamFromOrigin,
	getAddressStreet
}